/**
 * TanStack Query hook for fetching POI categories with parent-child hierarchy.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchPOICategories } from '../services/mapApi'

export function usePOICategories() {
  return useQuery({
    queryKey: ['poiCategories'],
    queryFn: ({ signal }) => fetchPOICategories({ signal }),
    staleTime: 30 * 60 * 1000, // 30 minutes - POI categories don't change frequently
    gcTime: 60 * 60 * 1000, // 1 hour
    refetchOnMount: false, // avoid duplicate fetches on StrictMode remount / nav back
  })
}
